<section class="service-detail-section">
    <div>
        <div class="service-header">
            <img [src]="'./assets/images/services/gardiennage-industriel.png'" [alt]="'gardiennage-industriel'" class="service-image">
            <div class="social-icons">
                <a href="#" class="social-link">
                    <img src="assets/images/icons/facebook.png" alt="Facebook">
                </a>
                <a href="#" class="social-link">
                    <img src="assets/images/icons/instagram.png" alt="Instagram">
                </a>
                <a href="#" class="social-link">
                    <img src="assets/images/icons/linkedin.png" alt="LinkedIn">
                </a>
            </div>
        </div>

        <div class="service-container">
            <div class="service-container-header">
                <div class="left-side">
                    <h1>Gardiennage <br>industriel
                    </h1>
                </div>
                <div class="right-side">
                    <a [routerLink]="['/routePath']" routerLinkActive="router-link-active" class="service-link">
                        <img src="assets/images/icons/shield_check.png" alt="Shield icon" class="link-icon">
                        <span class="link-text">Demander notre service</span>
                        <img src="assets/images/icons/link_arrow.png" alt="Arrow" class="arrow-icon">
                    </a>
                </div>
            </div>
            <div class="service-content">
                <h2>Nous avons pour mission d’assurer une surveillance constante des personnes, des équipements et des marchandises dans un but de prévention des risques de vol, incendie, vandalisme et du maintien continu des flux de production...</h2>
                <h3>Nous contrôlons si les travailleurs et les visiteurs respectent les prescriptions de sécurité.</h3>
                <p>Centres commerciaux, complexes immobiliers, les administrations, les établissements financiers, bureaux, sites industriels, entrepôts, parkings, chantiers, centres aquatiques, foires commerciales, parcs d’attractions, VIP, … </p>
                <p class="mt-5 mb-2">Missions types</p>
                <ul class="mb-4">
                    <li>Contrôle d’accès physique</li>
                    <li>Contrôles du personnel</li>
                    <li>Identification des visiteurs et fournisseurs</li>
                    <li>Réception et orientation des marchandises</li>
                    <li>Gestion et observation des images</li>
                    <li>Rondes externes et internes de prévention</li>
                    <li>Contrôle du respect des normes de sécurité</li>
                    <li>Contrôle du respect des normes d’hygiène</li>
                    <li>Prévention et lutte contre l’incendie</li>
                </ul>
                <p>La présence d’un agent de gardiennage constitue un élément de dissuasion efficace et peut être assurée 24h/24h – 7j/7j</p>
            </div>
        </div>
    </div>
</section>